var eventToListeners = {};

function sub(event, callback) {
    if (!eventToListeners.hasOwnProperty(event)) {
        eventToListeners[event] = [];
    }
    eventToListeners[event].push(callback);
}

function clearsub(event) {
    eventToListeners[event] = [];
}

function pub(event, ...args) {
    if (eventToListeners.hasOwnProperty(event)) {
        for (var i = 0; i < eventToListeners[event].length; ++i) {
            try {
                eventToListeners[event][i].call(null, ...args);
            } catch (e) {
                if (console && console.error) {
                    console.error(e);
                }
            }
        }
    }
}

export { sub, pub, clearsub };